(function () {
    'use strict';

    angular
        .module('salesflare.components.pricingSwitch', [])
        .component('sfPricingSwitch', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/pricingswitch/pricingswitch.html',
            bindings: {
                options: '<',
                selectedValue: '=',
                editPlan: '<'
            }
        });

    function controller($translate) {
        const vm = this;

        vm.getUsersText = function () {
            const count = vm.options.quantity;
            if (count === 1) {
                return $translate.instant('1 user');
            }

            return count + ' ' + $translate.instant('users');
        };

        vm.getYearForText = function () {
            return $translate.instant('/year for') + ' ' + vm.getUsersText();
        };

        vm.getMonthForText = function () {
            return $translate.instant('/month for') + ' ' + vm.getUsersText();
        };

        vm.getAllFeaturesText = function (planTitle) {
            return $translate.instant('and all the features available on the {{title}} plan', { title: planTitle });
        };
    }
})();
